export function WhatsApp({ label }: { label?: string }) {
  if (!label) return null;

  return (
    <div className="mt-2 flex items-center text-base text-gray-700">
      <img src="/whatsapp-retangular.png" alt="Whastapp" width={24} />
      <div className="ml-2">
        <span>
          <strong className="font-normal">{label}</strong>
        </span>
      </div>
    </div>
  );
}
